module.exports = __webpack_public_path__ + "img/aktiv.90ab7b91.jpg";